import axios from "axios";

const API_URL="https://miniapptech.in/blog_app/api_blogdetials.php";
console.log(API_URL);
export const getBlogs = async () => {
  try {
    const res = await axios.post(API_URL, {
      action: "get_blog_details"
    });

    return res.data;
  } catch (err) {
    console.error("Blog API Error:", err);
    return { status: false, data: [] };
  }
};